import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Example React App Deployed on GitHub pages</h1>
    </div>
  );
}

export default App;
